module.exports = new __parcel__URL__("trach.f6420adb.jpg").toString();